// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j2-6";
export var emphasizeQuantity = "_j2-3";
export var flatBottomCorners = "_j2-5";
export var productImage = "_j2-0";
export var quantityContainer = "_j2-2";
export var tooltip = "_j2-1";
export var wrapAndEllipsesOverflow = "_j2-4";